import { Component, OnInit, Inject, ViewChild, ElementRef, Input, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { HistoryProvider } from '../../core/browser-providers';
import { SecurityService } from '../security.service';
import { MediaService } from '../../shared-services/media.service';
import { Http, RequestOptionsArgs, Headers, Response } from '@angular/http';
import { NavigationService } from '../../shared-services/navigation.service';
import { NgForm } from '@angular/forms';
import { Role } from './role.model';
import {FormControl} from '@angular/forms';
import { MatSelectChange, MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import { Permission } from '../permission/permission.model';
import { Observer } from 'rxjs/Observer';
import { Observable } from 'rxjs/Observable';
import { ENTER } from '@angular/cdk/keycodes';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';

@Component({
  selector: 'app-role-add-edit',
  templateUrl: './role-add-edit.component.html',
  styleUrls: ['./role-add-edit.component.scss']
})
export class RoleAddEditComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER];

  @ViewChild('form') public roleForm: NgForm;

  toppings = new FormControl();
  @ViewChild('fruitInput') fruitInput: ElementRef;

  validationFail = false;
  role: Role;

  messageTitle: string;

  isHD = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    @Inject(HistoryProvider) private history: History,
    private securityService: SecurityService,
    private http: Http,
    private renderer: Renderer2,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
  ) { }

  permissionList: Observable<Permission[]>;

  ngOnInit() {

    this.route.data.subscribe(data => {
      this.role = data.role;

      if (!this.role.permissions) {
        this.role.permissions = [];
      }

    });

    this.messageTitle = this.role.id ? 'Edición de rol' : 'Alta de rol';

    this.permissionList = this.backendService.get(Permission, Permission.path + 'all', {});
    this.filter();
    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
  }

  back() {
    this.navigationService.back();
  }

  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }
    return;
  }

  remove(permission: Permission): void {
    const index = this.role.permissions.indexOf(permission);

    if (index >= 0) {
      this.role.permissions.splice(index, 1);
    }

    this.filter();
  }

  selected(event: MatAutocompleteSelectedEvent): void {

    for (const permission of this.role.permissions) {
      if (permission.id === event.option.value.id) {
        return;
      }
    }

    this.role.permissions.push(event.option.value);

    this.fruitInput.nativeElement.value = '';
    this.toppings.setValue(null);
    // this.renderer.invokeElementMethod(this.fruitInput.nativeElement, 'blur', []);
    this.filter();
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar el rol ' + this.role.name + '?')
    .then( res => {
      if (res) {
        this.saveRole(res);
      }
    });
  }

  async saveRole(res) {
    if (res) {

      this.snackService.spinner(true);

      if (this.role.id) { // Update
        try {
          await await this.backendService.update(Role.path + this.role.id, this.role);
          this.snackService.success('Rol editado');
          this.router.navigate(['/roles']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        try {
          await this.backendService.create(Role.path, this.role);
          this.snackService.success('Rol creado');
          this.router.navigate(['/roles']);
        } catch (ex) {
          this.snackService.error(ex);
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }

  public permissionSelected(permission: Permission): boolean {
    for (const rolePermission of this.role.permissions) {
      if (permission.id === rolePermission.id) {
        return true;
      }
    }
    return false;
  }

  private filter() {
    this.permissionList
    .map(permissions => permissions.filter(p => this.role.permissions.indexOf(p) === 0));
  }

}



// WEBPACK FOOTER //
// ./src/app/security/role/role-add-edit.component.ts